;globalThis["_sentryRewritesTunnelPath"] = undefined;globalThis["SENTRY_RELEASE"] = {"id":"534f7c8f878fce6d106980450683962310aa4aa5"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryNextJsVersion"] = "16.0.7";globalThis["_sentryRewriteFramesAssetPrefixPath"] = "/production";globalThis["_sentryAssetPrefix"] = "https://assets-v2.i-scmp.com/production";globalThis["_sentryExperimentalThirdPartyOriginStackFrames"] = undefined;globalThis["_sentryRouteManifest"] = "{\"isrRoutes\":[],\"dynamicRoutes\":[],\"staticRoutes\":[]}";import * as Sentry from "@sentry/nextjs";

import { config } from "shared/data";
import { sentryConfig } from "shared/lib/sentry/config";
import { supportedBrowsers } from "shared/lib/sentry/supported-browsers";

Sentry.init({
  ...sentryConfig,
  beforeSend: event => {
    // Filter out those browser is not in our supported list and user is not logged in
    if (
      (typeof navigator !== "undefined" && !supportedBrowsers.test(navigator.userAgent)) ||
      !event.user
    )
      return null;
    return event;
  },
  defaultIntegrations: false,
  integrations: [
    Sentry.extraErrorDataIntegration({ depth: 6 }),
    Sentry.browserTracingIntegration({
      enableInp: true,
    }),
  ],
  tracesSampleRate: config.sentry.enableTracing ? 0.1 : 0,
  transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
  tunnel: `${process.env.NEXT_PUBLIC_MONITORING_HOST}?apikey=${process.env.NEXT_PUBLIC_MONITORING_API_KEY}`,
});

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
